export const uppercaseFirst = str => {
  const safeStr = str || '';
  return safeStr.charAt(0).toUpperCase() + safeStr.substr(1);
};
export const stripMultipleSpaces = str => (str || '').replace(/\s+/g, ' ');
export const stripHTML = maybeString => (maybeString || '').replace(/<(?:.|\n)*?>/gm, '');



// WEBPACK FOOTER //
// ./src/shared/helpers/strings.js